import { formatBRL } from "@/lib/api";
import { Layers, AlertTriangle } from "lucide-react";

export function InscricaoGeralAviso({ existente, munNome, novosQtd, novosValor }) {
  if (!existente?.card_id) return null;
  const totalQtd = existente.quantidade + (Number(novosQtd) || 0);
  const totalValor = existente.valor_vendido + (Number(novosValor) || 0);
  return (
    <div className="rounded-xl border-2 border-blue-300 bg-blue-50 p-3 space-y-2" data-testid="insc-geral-aviso">
      <div className="flex items-start gap-2 text-sm text-blue-900">
        <Layers className="w-4 h-4 mt-0.5 shrink-0" />
        <div>
          <b>{munNome} já tem inscrição neste curso.</b> Esta será a <b>inscrição geral</b>: as novas pessoas entram junto com quem já está inscrito, em um só card e uma só NF.
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs tabular-nums">
        <div className="rounded-lg bg-white border border-blue-200 p-2" data-testid="insc-geral-atual">
          Já inscritos: <b>{existente.quantidade}</b> · <b>{formatBRL(existente.valor_vendido)}</b>
        </div>
        <div className="rounded-lg bg-blue-600 text-white p-2" data-testid="insc-geral-total">
          Inscrição geral: <b>{totalQtd}</b> · <b>{formatBRL(totalValor)}</b>
        </div>
      </div>
      {existente.nf_emitidas?.length > 0 && (
        <div className="flex items-start gap-2 text-xs text-red-800 bg-red-50 border border-red-200 rounded-lg p-2" data-testid="insc-geral-nf-emitida">
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          A NF nº {existente.nf_emitidas.join(", ")} já foi emitida. O Fiscal será avisado para cancelá-la e emitir a nova com todos.
        </div>
      )}
    </div>
  );
}
